// frontend_app/src/config.js

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Must match MIN_SEARCH_LENGTH in backend_api/skills/search_service.py.
// Two characters allows analyte codes such as "Fe", "Mg" or "Hb".
export const MIN_SEARCH_LENGTH = 2;

export const APP_NAME = 'TCM Search';

// Roles that may scrape lab websites live (mirrors LIVE_SEARCH_ROLES on the backend).
export const LIVE_SEARCH_ROLES = ['admin', 'user_live'];

export const ROLE_LABELS = {
  admin: 'Administrator',
  user_live: 'Cached + live search',
  user_db: 'Cached search only',
};

export const ROLE_DESCRIPTIONS = {
  user_db: 'Can search the cached lab databases.',
  user_live: 'Can search cached databases and scrape lab websites live.',
  admin: 'Full access, including data sources and user management.',
};
